<template>
  <el-config-provider :locale="elementEnLocale">
    <div>
      <ErrorBoundary>
        <component :is="$route.meta.layout || 'div'">
          <router-view />
        </component>
      </ErrorBoundary>
      <service-worker-update-popup />
    </div>
  </el-config-provider>
  <Toaster class="pointer-events-auto" />
</template>

<script setup lang="ts">
import { Toaster } from 'vue-sonner'
import { useCssVar } from '@vueuse/core'

import elementEnLocale from 'element-plus/es/locale/lang/en'
import { storeToRefs } from 'pinia'

import ErrorBoundary from '@/components/ErrorBoundary/index.vue'
import { eModules } from '@/constants'
import { appendFactoryDashboardRoutes } from '@/modules/module-factory-dashboard'
import { appendFactoryStudioRoutes } from '@/modules/module-factory-studio'
import ServiceWorkerUpdatePopup from '@/pwa/components/ServiceWorkerUpdatePopup.vue'
import { useUserStore } from '@/stores/user'

import { appendLogsRoutes } from './modules/module-logs'

// Computed properties
const { allowedModules } = storeToRefs(useUserStore())

const color2 = useCssVar('--el-color-primary', document.body, { initialValue: '#eee' })

color2.value = '#008000'

console.log('allowedModules', allowedModules.value)
if (allowedModules.value.includes(eModules.LOGS)) {
  console.log('appendLogsRoutes')
  appendLogsRoutes()
}

if (allowedModules.value.includes(eModules.FACTORY_DASHBOARD)) {
  console.log('appendFactoryDashboardRoutes')
  appendFactoryDashboardRoutes()
}

if (allowedModules.value.includes(eModules.FACTORY_STUDIO)) {
  console.log('appendFactoryStudioRoutes')
  appendFactoryStudioRoutes()
}
</script>

<style lang="sass">
@import '../node_modules/typeface-roboto/index.css'
@import '../node_modules/typeface-montserrat/index.css'
</style>
